/// TYPES ///
import { CSSProperties } from "react";

export const dialog_body_style: CSSProperties = {
  marginTop: "10px"
}
